import { sessionActions } from "../actions";
import { initialState } from "../initialState";
import { createReducer } from "./utilities";

const { session } = initialState;

const setJwtToken = (state, { token }) => {
  return { ...state, JwtToken: token };
};

const destroyJwtToken = (state) => {
  return { ...state, JwtToken: null };
};

const reset = (state) => {
  return { ...state, JwtToken: null };
};

const user = (state, { data: user }) => {
  return { ...state, user };
};

const updateUser = (state, { data }) => {
  return { ...state, user: data };
};

export const sessionReducer = createReducer(session, {
  [sessionActions.LOGIN]: setJwtToken,
  [sessionActions.LOGOUT]: destroyJwtToken,
  [sessionActions.ME]: user,
  [sessionActions.RESET]: reset,
  [sessionActions.UPDATE_ME]: updateUser
});
